import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DevisForm } from "@/components/DevisForm";

export const MobileDevisButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed inset-x-4 bottom-4 z-40 sm:hidden" data-testid="mobile-devis-bar">
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            data-testid="mobile-devis-button"
            className="h-12 w-full text-base font-semibold shadow-lg shadow-primary/30"
          >
            Demander un devis
          </Button>
        </DialogTrigger>
        <DialogContent data-testid="mobile-devis-dialog" className="max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Demande de devis</DialogTitle>
          </DialogHeader>
          <DevisForm onSuccess={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
